import { createSlice } from "@reduxjs/toolkit";

const totalCountSlice = createSlice({
  name: "totalCount",
  initialState: {
    loading: false,
    error: null,
    value: {},
  },
  reducers: {
    totalCountStart: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    totalCountSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      const collection = action.payload.meta.collection;
      state.value = {
        ...state.value,
        [collection]: action.payload.count || action.payload,
      };
    },
    totalCountFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.value = {};   
    },
  },
});

export const { totalCountStart, totalCountSuccess, totalCountFailure } =
  totalCountSlice.actions;

export default totalCountSlice.reducer;
